import { Type } from '@angular/core';
import { HelpTopicId } from '../../models/help.model';

type GuideLoader = () => Promise<Type<unknown>>;

export const HELP_GUIDE_LOADERS: Partial<Record<HelpTopicId, GuideLoader>> = {
  dashboard: () =>
    import('./dashboard-help-guide/dashboard-help-guide.component').then((m) => m.DashboardHelpGuideComponent),
  settings: () =>
    import('./settings-help-guide/settings-help-guide.component').then((m) => m.SettingsHelpGuideComponent),
  followupList: () =>
    import('./followup-list-help-guide/followup-list-help-guide.component').then(
      (m) => m.FollowupListHelpGuideComponent
    ),
  recurringFollowupList: () =>
    import('./recurring-followup-list-help-guide/recurring-followup-list-help-guide.component').then(
      (m) => m.RecurringFollowupListHelpGuideComponent
    ),
  recycleBin: () =>
    import('./recycle-bin-help-guide/recycle-bin-help-guide.component').then((m) => m.RecycleBinHelpGuideComponent),
  pendingTransactions: () =>
    import('./pending-transactions-help-guide/pending-transactions-help-guide.component').then(
      (m) => m.PendingTransactionsHelpGuideComponent
    ),
  customerStatement: () =>
    import('./customer-statement-help-guide/customer-statement-help-guide.component').then(
      (m) => m.CustomerStatementHelpGuideComponent
    ),
  commonStatement: () =>
    import('./common-statement-help-guide/common-statement-help-guide.component').then(
      (m) => m.CommonStatementHelpGuideComponent
    ),
  userProfile: () =>
    import('./user-profile-help-guide/user-profile-help-guide.component').then((m) => m.UserProfileHelpGuideComponent),
  customerProfile: () =>
    import('./customer-profile-help-guide/customer-profile-help-guide.component').then(
      (m) => m.CustomerProfileHelpGuideComponent
    ),
  addCustomer: () =>
    import('./add-customer-help-guide/add-customer-help-guide.component').then((m) => m.AddCustomerHelpGuideComponent),
  transferGroup: () =>
    import('./transfer-group-help-guide/transfer-group-help-guide.component').then(
      (m) => m.TransferGroupHelpGuideComponent
    ),
  pendingTransactionsDialog: () =>
    import('./pending-transactions-dialog-help-guide/pending-transactions-dialog-help-guide.component').then(
      (m) => m.PendingTransactionsDialogHelpGuideComponent
    ),
  entryCreate: () =>
    import('./entry-create-help-guide/entry-create-help-guide.component').then((m) => m.EntryCreateHelpGuideComponent),
  entryEdit: () =>
    import('./entry-edit-help-guide/entry-edit-help-guide.component').then((m) => m.EntryEditHelpGuideComponent),
  entryFollowUp: () =>
    import('./entry-followup-help-guide/entry-followup-help-guide.component').then(
      (m) => m.EntryFollowupHelpGuideComponent
    ),
  entryRecurringPayment: () =>
    import('./entry-recurring-payment-help-guide/entry-recurring-payment-help-guide.component').then(
      (m) => m.EntryRecurringPaymentHelpGuideComponent
    ),
  followupDialog: () =>
    import('./followup-dialog-help-guide/followup-dialog-help-guide.component').then(
      (m) => m.FollowupDialogHelpGuideComponent
    ),
  recurringFollowupDialog: () =>
    import('./recurring-followup-dialog-help-guide/recurring-followup-dialog-help-guide.component').then(
      (m) => m.RecurringFollowupDialogHelpGuideComponent
    ),
  aiVoice: () => import('./ai-voice-help-guide/ai-voice-help-guide.component').then((m) => m.AiVoiceHelpGuideComponent),
  aiChat: () => import('./ai-chat-help-guide/ai-chat-help-guide.component').then((m) => m.AiChatHelpGuideComponent),
  businessPopup: () =>
    import('./business-popup-help-guide/business-popup-help-guide.component').then(
      (m) => m.BusinessPopupHelpGuideComponent
    ),
  ledgerCustomerList: () =>
    import('../customer-list-help-guide/customer-list-help-guide.component').then(
      (m) => m.CustomerListHelpGuideComponent
    ),
  ledgerChat: () =>
    import('../chat-screen-help-guide/chat-screen-help-guide.component').then((m) => m.ChatScreenHelpGuideComponent)
};

export function hasHelpGuide(topic: HelpTopicId | null): boolean {
  return !!topic && topic in HELP_GUIDE_LOADERS;
}

export function loadHelpGuide(topic: HelpTopicId): Promise<Type<unknown>> {
  const loader = HELP_GUIDE_LOADERS[topic];
  if (!loader) {
    return Promise.reject(new Error(`No help guide for topic: ${topic}`));
  }
  return loader();
}
